<div>

  @switch (true) {
    @case (!!entry?.custom?.customDropdownSelection) {
      <app-required-docs-upload-special-enrollment
        #RequiredDocsUploadComponent
        [entry]="entry"
        [postFileInputBehavior]="triggerValidation()"
        [uploadFile]="uploadFile()"
        [removeFile]="removeFile()"
        [customConfigs]="entry?.custom"
        [existingDocs]="existingDocs"
      ></app-required-docs-upload-special-enrollment>
    }
    @default {
      <app-required-docs-upload
        #RequiredDocsUploadComponent
        [entry]="entry"
        [postFileInputBehavior]="triggerValidation()"
        [uploadFile]="uploadFile()"
        [removeFile]="removeFile()"
        [customConfigs]="entry?.custom"
        [existingDocs]="existingDocs"
      ></app-required-docs-upload>
    }
  }

  <br/>

  <!--
  The validator behavior on this, I just haven't figured out to do in a pleasing way without making a custom validator
  which I didn't feel like doing due to adding more json configurations on a monday; this should be fine for now
  -->
  @if (
    componentFormControls[entry.formControlAttributes?.formControlName]?.errors &&
    componentFormControls[entry.formControlAttributes?.formControlName]?.touched) {
    <mat-error>
      @if (componentFormControls[entry.formControlAttributes?.formControlName].errors.required) {
        <span>
          Please upload
          @if (entry?.custom?.minDocuments && entry?.custom?.maxDocuments) {
            @if (entry?.custom?.minDocuments === entry?.custom?.maxDocuments) {
              {{entry?.custom?.minDocuments}}
            }
            @if (entry?.custom?.minDocuments !== entry?.custom?.maxDocuments) {
              between {{entry?.custom?.minDocuments || 1}} and {{entry?.custom?.maxDocuments || 5}}
            }
          }
          files; And ensure there's no non-uploaded files present, above.
        </span>
      }
      @if (componentFormControls[entry.formControlAttributes?.formControlName].errors.itemsPending) {
        <span>
          Please wait for documents to complete their upload attempt before proceeding.
        </span>
      }
    </mat-error>
  }

</div>